import { useEffect, useState } from 'react';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { api, type Video } from '../api/client.ts';
import { useAuth } from '../auth/AuthContext.tsx';
import { ScreenHeader } from '../components/ui/ScreenHeader.tsx';
import { VideoCard } from '../components/VideoCard.tsx';
import './VideoListScreen.css';

export function VideoListScreen() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [videos, setVideos] = useState<Video[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .listVideos()
      .then(setVideos)
      .catch(() => setError('Не удалось загрузить список'));
  }, []);

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="screen">
      {/* No "+ Загрузить" action here — upload is admin-only, by direct URL. */}
      <ScreenHeader
        title="Мои видео"
        trailing={
          <button type="button" className="icon-button list-logout" onClick={handleLogout} aria-label="Выйти">
            <LogOut size={19} strokeWidth={2} />
          </button>
        }
      />
      <div className="screen-body video-list">
        {error && <div className="form-error">{error}</div>}
        {!error && videos === null && <div className="muted-note">Загрузка…</div>}
        {videos?.length === 0 && <div className="muted-note">Пока нет ни одной поездки</div>}
        {videos?.map((video) => (
          <VideoCard key={video.id} video={video} onOpen={() => navigate(`/video/${video.id}`)} />
        ))}
      </div>
    </div>
  );
}
